import { configureStore, combineReducers } from '@reduxjs/toolkit';
import loadingReducer from '../features/common/loadingSlice';
import notificationReducer from '../features/common/notificationSlice';
import authReducer from '../features/auth/authSlice';
import layoutReducer from '../features/layout/layoutSlice';
import workOrderReducer from '../features/workorders/workorderSlice';
import debtorReducer from '../features/debtors/debtorSlice';
import createWorkOrderReducer from '../features/workorders/workorderSlice';
import brandReducer from '../features/brands/BrandSlice';
import materialReducer from '../features/materials/MaterialSlice';
import artical from '../features/articles/ArticleSlice';
import quotationReducer from '../features/quotations/quotationSlice';
import articleGroupReducer from '../features/articlegroups/ArticleGroupSlice';
import creditureReducer from '../features/creditures/creditureSlice';
import invoiceReducer from '@application/features/invoices/invoiceSlice';
import orderReducer from '../features/orders/orderSlice';
import orderLineReducer from '../features/orderlines/orderLineSlice';
import planningReducer from '../features/plannings/planningSlice';
import calculationReducer from '../features/calculations/CalculationSlice';
import employeehourtypeReducer from '../features/employeehourtype/employeehourtypeSlice';
import jobcategoryReducer from '../features/jobcategory/jobcategorySlice';
import rolepermissionReducer from '../features/rolepermission/rolepermissionSlice';
import deliverynoteReducer from '../features/deliverynote/deliverynoteSlice';
import purchaseInvoiceReducer from '../features/purchaseInvoices/purchaseInvoiceSlice';
import purchaseInvoiceLineReducer from '../features/purchaseInvoiceLines/purchaseInvoiceLineSlice';
import documentationReducer from '../features/documentation/documentationSlice';
import workTypeReducer from '../features/workType/workTypeSlice';
import sendemailReducer from '../features/sendemail/sendemailSlice';
const combinedReducers = combineReducers({
    loading: loadingReducer,
    layout: layoutReducer,
    notification: notificationReducer,
    auth: authReducer,
    workorder: workOrderReducer,
    debtors: debtorReducer,
    createWorkOrder: createWorkOrderReducer,
    brands: brandReducer,
    material: materialReducer,
    artical: artical,
    articleGroup: articleGroupReducer,
    quotation: quotationReducer,
    crediture: creditureReducer,
    invoice: invoiceReducer,
    order: orderReducer,
    orderLine: orderLineReducer,
    planning: planningReducer,
    calculation: calculationReducer,
    employeehourtype: employeehourtypeReducer,
    rolepermission: rolepermissionReducer,
    jobCategory: jobcategoryReducer,
    deliveryNote: deliverynoteReducer,
    purchaseinvoice: purchaseInvoiceReducer,
    purchaseinvoiceline: purchaseInvoiceLineReducer,
    documentation: documentationReducer,
    workType: workTypeReducer,
    sendEmail: sendemailReducer
});
const rootReducer = (state, action) => {
    if (action.type === 'auth/logout') {
        return combinedReducers(undefined, action);
    }
    return combinedReducers(state, action);
};
export const store = configureStore({
    reducer: rootReducer
});
